import React from 'react';

function RenderFieldNormalInput({
  inputRef,
  input,
  type,
  className,
  disabled,
  placeholder,
  maxLength,
  meta: { touched, error },
}) {
  // const [typeInput, setTypeInput] = useState(type);

  // return (
  //   <input
  //       {...input}
  //       ref={inputRef}
  //       type={type}
  //       disabled={disabled}
  //       className={className}
  //       placeholder={placeholder}
  //       maxLength={maxLength || "256"}
  //       onFocus={(e) => e.currentTarget.select()}
  //       style={{
  //       borderColor: `${touched && error ? '#FF0000' : '#727E91'}`,
  //     }}
  //     />
  // )

  return (
    <div className="position-relative w-100">
      <input
        {...input}
        ref={inputRef}
        type={type}
        disabled={disabled}
        className={className}
        placeholder={placeholder}
        maxLength={maxLength || "256"}
        onFocus={(e) => e.currentTarget.select()}
        style={{
        borderColor: `${touched && error ? '#FF0000' : '#727E91'}`
      }}
      />
      {touched && error && (
        <div
          style={{
            color: '#FF0000',
            margin: '0 0 10px',
            fontSize: '0.75rem',
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
}

export default RenderFieldNormalInput;
